import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Grid, ListItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import humanDateReader from '../../services/util/humanDateReader';
import { ArrowIcon } from '../../theme/styled-components';
import { Notification } from '../../types/notification';
import styles from './styles';

export interface NotificationListItemProps {
  classes?: Record<string, string>;
  notification?: Notification;
  openingNotification?: (...args: unknown[]) => void;
}

function NotificationListItem({
  classes = {},
  notification = {},
  openingNotification = () => {},
}: NotificationListItemProps) {
  const navigate = useNavigate();

  return (
    <Box className={classes.root}>
      <ListItem
        className={`notificationsListItem ${
          notification.IsRead ? 'notificationread' : 'notificationunread'
        } ${notification.disabled && 'disabled'}`}
        data-testid="notification-list-item"
      >
        <Button
          className={classes.notificationButton}
          data-testid={
            notification.IsRead
              ? 'notification-list-item-button-read'
              : 'notification-list-item-button-unread'
          }
          onClick={(e) => openingNotification(e, notification, navigate)}
        >
          <Grid container alignItems="center">
            {!notification.IsClicked ? (
              <Box
                className={classes.newNotification}
                data-testid="notification-list-item-indicator"
              />
            ) : (
              ''
            )}
            <Grid className="notificationMessageGridItem" item xs={11} md={8}>
              <Box className={classes.notificationitem}>
                <Typography
                  className={classes.notificationText}
                  data-testid="notification-list-item-message"
                  variant="body1"
                >
                  {notification.Message}
                </Typography>
                <Typography
                  className={classes.notificationlink}
                  data-testid="notification-list-item-link"
                  variant="body2"
                >
                  {notification.LinkText}
                  <ArrowIcon className={classes.arrowIcon} />
                </Typography>
              </Box>
            </Grid>
            <Grid
              className={classes.notificationDateGridItem}
              item
              xs={10}
              md={notification.IsClicked ? 4 : 3}
            >
              <Typography
                className={classes.notificationDate}
                data-testid="notification-list-item-date"
                variant="body2"
              >
                {notification.createdAt &&
                  humanDateReader(notification.createdAt)}
              </Typography>
            </Grid>
          </Grid>
        </Button>
      </ListItem>
    </Box>
  );
}

export default withStyles(styles)(NotificationListItem);
